import { TopBar } from './TopBar';
import { Sidebar } from './Sidebar';
import { RightPanel } from './RightPanel';
import { CommandPalette } from './CommandPalette';
import { AskAiBar } from '@/components/ai/AskAiBar';

/**
 * 3-pane layout shell — top bar, left sidebar (endpoints), main content,
 * right panel (code snippets + response + AI chat).
 *
 * - Sidebar collapsed below 1024px (handled inside Sidebar component)
 * - Right panel hidden below 1280px (handled inside RightPanel component)
 * - Ask-AI bar punya 2 mount point dengan shared state:
 *     - Mobile/tablet (<xl): sticky di bawah main column ("bottom" variant)
 *     - Desktop (xl+): integrated ke RightPanel sebagai 3rd pane ("right" variant)
 *   Visibility di-toggle via responsive class — bottom mount xl:hidden,
 *   right mount built-in karena RightPanel itself hidden xl:flex.
 */
export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="h-screen flex flex-col bg-base">
      <CommandPalette />
      <TopBar />
      <div className="flex-1 flex overflow-hidden">
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <main className="flex-1 overflow-y-auto">{children}</main>
          {/* Mobile/tablet: bottom-anchored AI bar */}
          <div className="xl:hidden">
            <AskAiBar variant="bottom" />
          </div>
        </div>
        <RightPanel />
      </div>
    </div>
  );
}
